// Enable2FA.js
import React, { useState } from 'react';
import { enable2fa } from '../../util/api';
import { FormattedMessage } from '../../util/reactIntl';
import { PrimaryButton, Verify2FA, H4 } from '../../components';

import css from './Enable2FA.module.css';

export default function Enable2FA({ user, intl, onUpdateProfile, onFetchCurrentUser }) {
  const [qrCode, setQrCode] = useState(null);

  const userId = user?.id?.uuid;
  const twoFAEnabled = user?.attributes?.profile?.protectedData?.twoFAEnabled;
  const handleEnable = async () => {
    const res = await enable2fa({ userId });
    setQrCode(res.data.qrCode);
  };
  const handleDisable = async () => {
    const params = {
      protectedData: {
        twoFAEnabled: false,
        twoFASecret: '',
      },
    };
    const res = await onUpdateProfile(params);
  };

  const onVerified = async () => {
    const res = await onFetchCurrentUser();
  };

  return (
    <div>
      <H4 as="h2" className={css.sectionTitle}>
        <FormattedMessage
          id={
            twoFAEnabled
              ? 'Enable2FA.twoFactorAuthenticationEnabled'
              : 'Enable2FA.twoFactorAuthentication'
          }
        />
      </H4>
      <div className={css.securityContainer}>
        {twoFAEnabled ? (
          <p>
            <FormattedMessage id="Enable2FA.enable2FAEnabled" />
          </p>
        ) : (
          <label>
            <FormattedMessage id="Enable2FA.enable2FA" />
          </label>
        )}
      </div>
      <PrimaryButton
        className={css.enable2fa}
        onClick={twoFAEnabled ? handleDisable : handleEnable}
      >
        <FormattedMessage id={twoFAEnabled ? 'Enable2FA.disable2fa' : 'Enable2FA.enable2fa'} />
      </PrimaryButton>
      {qrCode && !twoFAEnabled && (
        <div className={css.qrContainer}>
          <p>
            <FormattedMessage id="Enable2FA.scanQrCode" />
          </p>
          <img
            src={qrCode}
            alt={intl.formatMessage({
              id: 'ProfileSettingsForm.2FaQrCode',
            })}
          />
          <div className={css.verify2FA}>
            <Verify2FA userId={userId} onVerified={onVerified} />
          </div>
        </div>
      )}
    </div>
  );
}
